import { render } from "./TagTemplate.vue?vue&type=template&id=8221f27c&scoped=true"
import script from "./TagTemplate.vue?vue&type=script&lang=js"
export * from "./TagTemplate.vue?vue&type=script&lang=js"

import "./TagTemplate.vue?vue&type=style&index=0&id=8221f27c&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8221f27c"]])

export default __exports__